const SEARCH_PARAMS = new URLSearchParams(window.location.search)

export function getParameterByName(name, searchParams = SEARCH_PARAMS) {
  return searchParams.get(name)
}

export default class QueryParam {
  static getQueryParam(keys = []) {
    return this.getQueryParamWithCookie(keys)
  }

  static getQueryParamWithCookie(keys = [], cookie = {}) {
    try {
      const param = {}
      keys.forEach((key) => {
        param[key] = getParameterByName(key) ?? cookie[key]
      })

      return param
    } catch (e) {
      console.error(e)
      return {}
    }
  }

  static getSearchParamStr(params = '') {
    try {
      const searchParams = params instanceof URLSearchParams ? params : new URLSearchParams(params)
      const paramStr = searchParams.toString()
      return paramStr ? `?${paramStr}` : ''
    } catch (e) {
      console.error(e)
      return ''
    }
  }
}
